<template>
  <div>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="70%"
      ref="drawerRef"
      v-loading.fullscreen.lock="loading"
      :with-header="true"
    >
      <el-container>
        <el-main>
          <el-row>
            <el-col>
              <el-form
                :model="companyData"
                label-position="left"
                size="mini"
                label-width="150px"
              >
                <el-collapse accordion v-model="activeColapseName">
                  <el-collapse-item name="1">
                    <template slot="title" class="name_clicked">
                      <h2 title="Dar click para collpsar">
                        {{ companyData.Name }}
                      </h2>
                      <i class="header-icon el-icon-information"></i>
                    </template>
                    <hr />

                    <el-row :gutter="20" class="mt-20" type="flex column">
                      <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                        <el-form-item label="Id">
                          <el-input
                            v-model="companyData.Id"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>

                        <el-form-item label="Codigo">
                          <el-input
                            v-model="companyData.Code"
                            :disabled="true"
                          />
                        </el-form-item>

                        <el-form-item label="Name">
                          <el-input
                            v-model="companyData.Name"
                            :disabled="true"
                          />
                        </el-form-item>

                        <el-form-item label="Integration Portal">
                          <el-radio-group
                            v-model="companyData.IntegrationPortal"
                            :disabled="true"
                          >
                            <el-radio :label="true">Si</el-radio>
                            <el-radio :label="false">No</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>

                      <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                        <el-form-item label="Contacto">
                          <el-input
                            v-model="companyData.Contact"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>

                        <el-form-item label="Phone Number 1">
                          <el-input
                            v-model="companyData.Telephone1"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>

                        <el-form-item label="Phone Number 2">
                          <el-input
                            v-model="companyData.Telephone2"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>

                        <el-form-item label="Company Database">
                          <el-input
                            v-model="companyData.CompanyDatabaseName"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>
                      </el-col>

                      <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                        <el-form-item label="Creation Date">
                          <el-input
                            v-model="companyData.CreatedAt"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>

                        <el-form-item label="Address 1">
                          <el-input
                            v-model="companyData.Address1"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>

                        <el-form-item label="Address 2">
                          <el-input
                            v-model="companyData.Address2"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>

                        <el-form-item label="Secret Key">
                          <el-input
                            v-model="companyData.SecretKey"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                </el-collapse>

                <el-collapse accordion v-model="activeColapseTable">
                  <el-collapse-item name="1">
                    <template slot="title" class="name_clicked">
                      <h2 title="Dar click para collpsar">Branch Offices</h2>
                      <i class="header-icon el-icon-information"></i>
                    </template>
                    <hr />

                    <el-row :gutter="20" class="mt-50" type="flex column">
                      <el-col>
                        <vue-scroll>
                          <div class="flex justify-flex-end">
                            <rabbey-toolbox
                              :filterables="true"
                              @filter-search="search = $event"
                            >
                              <div class="box mr-15">
                                <el-button
                                  size="mini"
                                  type="primary"
                                  round
                                  icon="el-icon-plus"
                                  @click="showBranchOffices"
                                  ><b>New Branch Offices</b></el-button
                                >
                              </div>
                            </rabbey-toolbox>
                          </div>

                          <el-row>
                            <el-col>
                              <rabbey-table3
                                ref="subCompanyTable"
                                :data="subCompanyData"
                                :search="search"
                                key-search="Name"
                                :columns="companyColumns"
                                :actions="companyActions"
                                :defaultParams="defaultParams"
                                :paginateFromApi="false"
                                @rtable-push-action="onPushAction"
                              />
                            </el-col>
                          </el-row>
                        </vue-scroll>
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                </el-collapse>
              </el-form>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>
    <DialogNewBranchOffices ref="subCompany" :companyId="this.companyData.Id" />
  </div>
</template>
<script>
import DialogNewBranchOffices from "../../components/Company/DialogSubCompany.vue";
import RabbeyTable3 from "../../components/RabbeyTable3";

export default {
  name: "CompanyDetails",
  components: {
    DialogNewBranchOffices,
    "rabbey-table3": RabbeyTable3
  },
  data() {
    return {
      drawer: false,
      search: "",
      companyData: [],
      subCompanyData: [],
      activeColapseName: ["1"],
      activeColapseTable: ["1"],
      title: "Company Details",
      loading: false,
      innerDrawer: false,
      dialogFormVisible: false,
      direction: "rtl",
      branchForm: {},
      formLabelWidth: "120px",
      companyColumns: [
        {
          prop: "Code",
          label: "Code",
          sortable: true
        },
        {
          prop: "Name",
          label: "Name",
          sortable: true
        },
        {
          prop: "Contact",
          label: "Contact",
          sortable: true
        },
        {
          prop: "Telephone1",
          label: "Phone Number"
        },
        {
          prop: "IsActive",
          label: "Active"
        }
      ],
      companyActions: [
        {
          icon: "el-icon-edit",
          label: "Edit Branch Offices",
          command: "editBranchOffices"
        },
        {
          icon: "el-icon-delete",
          label: "Delete Branch Offices",
          command: "deleteBranchOffices"
        }
      ]
    };
  },

  computed: {
    // Set Default Company
    defaultParams() {
      return {
        status: 0,
        companyCode: this.currentCompany
      };
    }
  },
  methods: {
    showCompany(data) {
      this.companyData = data;
      this.getSubCompanyData();
      this.drawer = true;
    },
    showBranchOffices() {
      this.$refs.subCompany.showModal(null);
    },
    handleClosed() {
      this.$emit("update:drawer", false);
      this.$refs.el_form.resetFields();
    },
    onPushAction(options) {
      switch (options.command) {
        case "editBranchOffices":
          this.$refs.subCompany.showModal(options.row);
          break;

        case "deleteBranchOffices":
          this.$confirm("Segura/o que desea eliminar este registro ?")
            .then(() => {
              this.$http
                .delete(
                  `/api/companies/${this.companyData.Id}/Groups/${options.row.Id}`
                )
                .then(() => {
                  this.$message.success("Sub Company Deleted Sucessfully.");
                })
                .catch((error) => {
                  console.error(error);
                  this.$message.error("Error Trying Delete Sub Company.");
                })
                .finally(() => {
                  this.loading = false;
                });
            })
            .catch(() => {
              this.$message.info("Operation Canceled");
            });
          break;
        case "editCompany":
          this.$refs.newCompany.editCompany(
            options,
            "Edit Company",
            false,
            true
          );
          break;
        default:
          break;
      }
    },
    getSubCompanyData() {
      this.loading = true;
      this.subCompanyData = [];
      this.$http
        .get(`api/companies/${this.companyData.Id}/Groups`)
        .then(({ data }) => {
          this.subCompanyData = data;
        })
        .catch((error) => {
          this.$message.error("Error al consultar las sub companias");
          console.error(error);
          this.subCompanyData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
